/**
 *
 *  Port over the legacy darklaunch utils
 *
 *      Examples of using:
 *
 *      var darklaunchUtil = require('src/interlock/no-ui/utils/darklaunch/darklaunch');
 *
 *      if (darklaunchUtil.storyEnabled('mad-2432')) {
 *           // new code
 *      } else {
 *           // old code
 *      };
 *
 *      Link to page with a new code:
 *      edmunds.com/groundwork/honda/accord/2017/sedan/?story-id=mad-2432
 *
 *      Please note that the cookie "storyId" activates a new code
 *      
 */

var queryString = require('query-string'),
    cookies = require('src/interlock/no-ui/utils/cookies/cookies');

var stories = null;

var DARK_SIDE_PARAMETER = 'darkside';
var DARK_SIDE_ENABLE_ARRAY = ['yes', 'true', '1'];
var STORY_ID_PARAMETER = 'story-id';
var STORY_ID_COOKIE  = 'storyId';

function _getRequestParameter(param, defaultValue) {
    var queryStringObject = queryString.parse(window.location.search) || {};
    return queryStringObject[param] || defaultValue;
}

/**
 * Initialize cookie
 *
 */
function initialize() {
    _initStories();
}

/**
 * Checking is a request parameter present and darklaunch is on
 *
 * @param {String} storyId the string with darklaunched request parameter (e.g. 'FIND-871')
 *
 * @return {boolean} true if the request parameter is present
 */
function storyEnabled(storyId) {
    var darkSide = _getRequestParameter(DARK_SIDE_PARAMETER, null);
    if (darkSide !== null && (DARK_SIDE_ENABLE_ARRAY.indexOf(darkSide) > -1 )) {
        return true;
    }

    _initStories();

    return stories[storyId.toUpperCase()] === true;
}

function _initStories() {
    if (!stories) {
        stories = _getStoryIds(_getRequestParameter(STORY_ID_PARAMETER, ''))
            .concat(_getStoryIds(cookies.getItem(STORY_ID_COOKIE) || ''))
            .reduce(function (map, key) {
                map[key.toUpperCase()] = true;
                return map;
            }, {}
            );
        _resetStoryIdCookie();
    }
}

function _resetStoryIdCookie() {
    var ids = [];
    for (var id in stories) {
        if (stories.hasOwnProperty(id)) {
            ids.push(id);
        }
    }
    if (ids.length > 0) {
        cookies.setItem(STORY_ID_COOKIE, ids.join(','));
    }
}

function _getStoryIds(str) {
    var storyIdArr = str;
    if(typeof str === 'string') {
        storyIdArr = str.split(',');
    }
    return storyIdArr.filter(function(id) {
        return id.length > 0;
    });
}


module.exports = {
    initialize: initialize,
    storyEnabled: storyEnabled
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/darklaunch/darklaunch.js
// module id = 14
// module chunks = 36